import { css } from 'lit';

export default css`
  :host {
    display: block;
    font-family: var(--font-family-base, 'Inter, Arial, sans-serif');
    width: 100%;
    max-width: 100%;
  }

  .progress-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: var(--spacing-sm, 8px);
    width: 100%;
    height: 20px;
  }

  .label-slot, ::slotted([slot="label"]) {
    font-size: var(--font-size-b3, 14px);
    line-height: var(--line-height-b3, 20px);
    font-weight: var(--font-weight-regular, 400);
    flex: none;
    color: var(--color-dark-gray-2, #030711);
    display: inline-flex;
    align-items: center;
  }

  .progress-bar {
    height: 8px;
    background: var(--color-gray-2, #e7e5e4);
    border-radius: var(--radius-sm, 8px);
    overflow: hidden;
    position: relative;
    flex: 1;
  }

  .fill {
    height: 100%;
    background: var(--progress-fill-bg, var(--color-secondary, #2594e3));
    border-radius: var(--radius-sm, 8px);
    transition: width 0.3s ease-in-out;
  }

  /* States */
  :host([state="active"]) .label-slot,
  :host([state="active"]) ::slotted([slot="label"]) {
    color: var(--color-dark-gray-2, #030711);
  }

  :host([state="disabled"]) .progress-wrapper {
    opacity: 0.7;
  }

  :host([state="disabled"]) .label-slot,
  :host([state="disabled"]) ::slotted([slot="label"]) {
    color: var(--color-gray-6, #7c7c7c);
  }

  :host([state="disabled"]) .progress-bar {
    background: var(--color-gray-1, #f7f5f4);
  }

  :host([state="disabled"]) .fill {
    background: var(--color-gray-1, #f7f5f4);
  }

  @media (max-width: 768px) {
    .progress-wrapper {
      gap: var(--spacing-xs, 6px);
      height: 16px;
    }
    .label-slot, ::slotted([slot="label"]) {
      font-size: var(--font-size-b4, 12px);
    }
    .progress-bar {
      height: 6px;
    }
  }
`;